import { Directive, ElementRef, inject } from '@angular/core';
import { coerceElement } from '@angular/cdk/coercion';
import { CdkDropList } from '@angular/cdk/drag-drop';

// CDK never offers a list as a target for drags that started in it, so an outer connected list
// that contains it swallows the item: https://github.com/angular/components/issues/16671
@Directive({ selector: '[cdkDropList][webNestedDropList]' })
export class NestedDropListDirective {
    private readonly dropListRef = inject(CdkDropList)._dropListRef;
    private readonly element: HTMLElement = inject(ElementRef).nativeElement;

    constructor() {
        const findSibling = this.dropListRef._getSiblingContainerFromPosition.bind(this.dropListRef);

        this.dropListRef._getSiblingContainerFromPosition = (item, x, y) => {
            const sibling = findSibling(item, x, y);
            const isOuterList = !!sibling && coerceElement(sibling.element).contains(this.element);

            return isOuterList && this.dropListRef._canReceive(item, x, y) ? this.dropListRef : sibling;
        };
    }
}
